import moment from 'moment';
import { convertTime } from 'src/helpers/time';

export interface LastUpdatedPill {
  text: string;
  color: string;
}

const LAST_UPDATED_PILL_COLOR = '#6b7280';

/* The API returns updatedAt already converted to the tenant time zone (see
 * JuniperDateTimeService on the backend), so the FE only formats it — no tz
 * math here. It's null for service requests that have never been updated; we
 * also defensively treat the .NET default DateTime (0001-01-01) as "no update
 * yet" in case a legacy/Dapper path still emits the sentinel. */
export const getLastUpdatedPill = (
  updatedAt: string | null | undefined
): LastUpdatedPill => {
  const parsed = moment(updatedAt);

  if (!updatedAt || !parsed.isValid() || parsed.year() <= 1) {
    return { text: 'Last updated: N/A', color: LAST_UPDATED_PILL_COLOR };
  }

  const formattedDate: string = convertTime(updatedAt, 'date');

  return {
    text: `Last updated: ${formattedDate}`,
    color: LAST_UPDATED_PILL_COLOR,
  };
};